import React from 'react';
import { useSelector } from 'react-redux';
import { TrackReferenceOrPlaceholder } from '@livekit/components-core';
import { styled } from '@mui/material/styles';
import { selectLowerThirdsPercentage } from '../../../../redux/slices/room';
import { ParticipantTileMinimal } from '../../../LiveKit/ParticipantTileMinimal';
import { FullscreenVideoContained } from '../../Styled';

const GridContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100vw',
});

const VideoContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
});

const Row = styled('div')<{
  lowerThirdsPercentage: number;
}>(({ lowerThirdsPercentage }) => {
  const height = `${lowerThirdsPercentage}vh`;
  return {
    display: 'flex',
    justifyContent: 'center',
    width: lowerThirdsPercentage === 100 ? '100vw' : 'auto',
    height,
  };
});

interface IRtmpTrackViewLayout {
  videoTrack?: TrackReferenceOrPlaceholder;
}

export const RtmpTrackViewLayout = ({ videoTrack }: IRtmpTrackViewLayout) => {
  const lowerThirdsPercentage = useSelector(selectLowerThirdsPercentage);

  return (
    <GridContainer>
      <Row lowerThirdsPercentage={100 - lowerThirdsPercentage}>
        {videoTrack ? (
          <VideoContainer key={videoTrack.participant.sid}>
            <ParticipantTileMinimal
              className={'videoCam'}
              trackRef={videoTrack}
            />
          </VideoContainer>
        ) : (
          <FullscreenVideoContained
            autoPlay={true}
            height={`${100 - lowerThirdsPercentage}vh`}
            id="mediaVideo_error_video"
            key="mediaVideo_error_video"
            loop={true}
            muted={true}
            src="https://cdn-aws.s3.eu-west-1.amazonaws.com/webcamGo/langs/en/error.mp4"
          />
        )}
      </Row>
    </GridContainer>
  );
};
